import './sass/style.scss';
import './js/app.js';

import * as components0 from '../views/components/menu/horizontal/horizontal.js'; import * as components1 from '../views/components/searchform/index.js'; import * as components2 from '../views/components/slider/basic/index.js'; let components = [components0, components1, components2];
import * as blocks0 from '../views/blocks/BannerSlider/index.js'; import * as blocks1 from '../views/blocks/ProductsSlider/index.js'; let blocks = [blocks0, blocks1];
;
